import { Field } from 'formik'

/**
 * Helper function to assist with managing formik arrays
 *
 * @param {string} name - The name of the formik key
 * @param {any[]} values - The array of values from formik
 * @param {Function} setFieldValue - The function to set the field's value
 */
const helper = (name: any, values = [], setFieldValue: any) => {
  return {
    push: (newValue: any) => {
      setFieldValue(name, [...values, newValue])
    },
    remove: (index: any) => {
      const filteredArray = values.filter((_, idx) => idx !== index)
      setFieldValue(name, filteredArray)
    }
  }
}

/**
 * withFieldArray - A higher order component to connect a component to Formik without using `connect()`
 *
 * Same with the `withField` but passing a helper function into the component to manage array fields
 */
const withFieldArray = (WrappedComponent: any) => {
  return function FieldArray(props: any) {
    return (
      <Field name={props.name}>
        {({ field: { value }, form: { setFieldValue, setValues, errors, touched } }: any) => {
          return (
            <WrappedComponent
              helper={helper(props.name, value, setFieldValue)}
              value={value}
              setValues={setValues}
              errors={errors}
              touched={touched}
              setFieldValue={setFieldValue}
              {...props}
            />
          )
        }}
      </Field>
    )
  }
}

export default withFieldArray
